module.exports = __webpack_public_path__ + "img/4.e2016f82.png";